<script setup>
defineProps({
  size: {
    type: String,
    default: 'md',
    validator: value => ['sm', 'md', 'lg'].includes(value),
  },
  spinning: {
    type: Boolean,
    default: true,
  },
  inline: Boolean,
})
</script>

<template>
  <div
    class="d-loader p-2 text-center"
    :class="{ inline, 'flex justify-center': !inline }"
  >
    <svg
      viewBox="0 0 24 24"
      :class="{
        inline,
        'animate-spin': spinning,
        'h-4 w-4': size === 'sm',
        'h-6 w-6': size === 'md',
        'h-12 w-12': size === 'lg',
      }"
    >
      <path
        fill="currentColor"
        d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
      />
    </svg>
  </div>
</template>
